module.exports = __webpack_public_path__ + "img/zjs2.280166d0.png";